import * as vp from 'vopay';

import { FunctionComponent, useMemo } from 'react';

import { DialogueHandler, OnboardingUrlDialogueHandlers } from '../types';

const { ConfirmationDialogue } = vp;

type OnboardingUrlDialogueProps = {
  fetchOnboardingUrl: {
    showFetchOnboardingUrlErrorAlert: boolean;
    fetchOnboardingUrlError: string;
  };
  generateOnboardingUrl: {
    showGenerateOnboardingUrlErrorAlert: boolean;
    generateOnboardingUrlError: string;
  };
  handleDialogue: DialogueHandler<OnboardingUrlDialogueHandlers>;
};

type FC = FunctionComponent<OnboardingUrlDialogueProps>;

const OnboardingUrlDialogue: FC = ({
  fetchOnboardingUrl,
  generateOnboardingUrl,
  handleDialogue,
}: OnboardingUrlDialogueProps) => {
  const { showFetchOnboardingUrlErrorAlert, fetchOnboardingUrlError } = fetchOnboardingUrl;
  const { showGenerateOnboardingUrlErrorAlert, generateOnboardingUrlError } = generateOnboardingUrl;

  return useMemo(
    () => (
      <div>
        {/* Fetch Token Failure */}

        <ConfirmationDialogue
          isVisible={showFetchOnboardingUrlErrorAlert}
          title="Error! Your onboarding url could not be retrieved."
          subTitle={fetchOnboardingUrlError}
          status="error"
          confirm={{
            label: 'Back to Accounts',
            action: () => handleDialogue({ type: 'retrieval', state: 'fail', hasNavigation: true }),
          }}
          cancel={{
            label: 'Stay Here',
            action: () => handleDialogue({ type: 'retrieval', state: 'fail', hasNavigation: false }),
          }}
        />

        {/* Generate Token Failure */}

        <ConfirmationDialogue
          isVisible={showGenerateOnboardingUrlErrorAlert}
          title="Error! Your onboarding url generation was not successful."
          subTitle={generateOnboardingUrlError}
          status="error"
          confirm={{
            label: 'Back to Accounts',
            action: () => handleDialogue({ type: 'generation', state: 'fail', hasNavigation: true }),
          }}
          cancel={{
            label: 'Stay Here',
            action: () => handleDialogue({ type: 'generation', state: 'fail', hasNavigation: false }),
          }}
        />
      </div>
    ),
    [
      showFetchOnboardingUrlErrorAlert,
      fetchOnboardingUrlError,
      showGenerateOnboardingUrlErrorAlert,
      generateOnboardingUrlError,
    ],
  );
};

export default OnboardingUrlDialogue;
